import { cr, ck } from "fire-wind-water";
import * as sbaseData from "../common/sbase";
import service from "../service/form";

export default {
  data() {
    return {
      signUp: {},
      isHaveCode: false, //是否有验证码
      identity: "",
      identityPlaceholder: "",
      identityPlaceholderDefault: "手机/邮箱/身份证号",
      identityRule: {
        pattern: {},
        required: true,
      },
      d: window.$sk.template.get().common,
      code: "",
      error: {
        identityText: "",
        codeText: "",
      },
      isRunning: false,
      initialNum: 60,
      timer: "",
      isShowPhoneTips: false,
    };
  },
  mounted() {
    if (!sbaseData.isSetting) {
      this.signUp = {
        path: `${this.platform}_index`,
        query: { urlForm: "verify" },
      };
    }
  },
  methods: {
    init() {
      this.webinarId = sbaseData.webinarId;
      if (this.formInfo.moduleType == "2") {
        this.webinarId = this.formInfo.objectId;
      }
      const wechatInfo = ck.cookie(
        "verifyInfo_" + this.formInfo.attachWXAccount
      );
      this.openId = wechatInfo ? wechatInfo.original.openid : "";
      this.commonWebinar();

      //获取报名状态
      this.getSignupStatus();
    },
    getSignupStatus() {
      //身份信息
      if (
        this.webinarId &&
        (this.member || this.openId || ck.cookie("globalUserId"))
      ) {
        service
          .webinarContactsGet({
            tenantId: this.tenantId,
            webinarId: this.webinarId,
            sess: this.member ? this.member.session : "",
            openId: this.openId,
            globalUserId: ck.cookie("globalUserId"),
          })
          .subscribe(
            (data) => {
              if (data.content.isSignUp) {
                if (sbaseData.returnUrl) {
                  window.$sk.goto(sbaseData.returnUrl);
                } else {
                  this.$router.push({
                    path: `${this.platform}_index`,
                    query: this.d.router,
                  });
                }
                return false;
              }
              this.afterGetSignupStatus();
            },
            (error) => {
              console.log(error);
            }
          );
      } else {
        this.afterGetSignupStatus();
      }
    },
    afterGetSignupStatus() {
      let identityFields = [];
      this.formInfo.items.forEach((field) => {
        if (field.isLogin == "1") {
          if (field.fieldName === "mobile" && field.isCallingCodeOpen == 1) {
            this.isShowPhoneTips = true;
          }
          identityFields.push(field);
        }
      });
      this.setIdentities(identityFields);
    },
    setIdentities(fields) {
      this.identityPlaceholder = fields
        .map((item) => {
          return item["displayName"];
        })
        .join("/");

      console.log(this.identityPlaceholder);

      if (cr.isPlainObject(fields)) {
        fields = [fields];
      }

      //if (this.identityRule.rules) {
      //  this.identityRule.rules.remove(function (item) {
      //    return item.rule === 'required' || item.rule === 'pattern';
      //  });
      //}
      //self.identityPlaceholder($.map(fields, function (item) {
      //  return item['displayName'];
      //}).join('/'));

      this.identityRule = {
        required: {
          message: "请填写" + this.identityPlaceholder,
        },
      };

      let regexs = [];
      let regexMessage = [];
      fields.forEach((item) => {
        //预设校验或自定义校验
        let regExpression =
          item.regularExpression || item.textRegularExpression || ""; //预设/自定义校验规则
        regexs.push(regExpression);
        regexMessage.push(item.displayName);
        //rules.push({'key':item.fieldName,'rule':regExpression});
      });

      if (regexs && regexs.length > 0) {
        this.identityRule.pattern = {
          params: "(" + regexs.join(")|(") + ")",
          message: "请填写正确的" + regexMessage.join("/"),
        };
        console.log(this.identityRule);
      }

      window.$sk.loading.hide();
    },
    isValid() {
      this.error = {
        identityText: "",
        codeText: "",
      };
      if (!this.identity) {
        this.error.identityText = this.identityRule.required.message;
        return false;
      } else if (
        this.identityRule.pattern.params &&
        !new RegExp(this.identityRule.pattern.params).test(this.identity)
      ) {
        this.error.identityText = this.identityRule.pattern.message;
        return false;
      }
      return true;
    },

    // 发送验证码
    sendCode() {
      if (this.isValid()) {
        this.startCounter();
        service
          .codeSendwithoutform({
            tenantId: parseInt(this.tenantId),
            unique: this.identity,
          })
          .subscribe((data) => {
            if (data.result == "0") {
              if (data.content.result != "1") {
                window.$sk.tips.show(data.desc);
                this.clearCounter();
              }
            } else {
              window.$sk.tips.show(data.desc);
              this.clearCounter();
            }
          });
      }
    },

    /*开始计时*/
    startCounter() {
      this.isRunning = true;
      this.initialNum = 60;
      this.timer = window.setInterval(() => {
        this.initialNum = this.initialNum - 1;
        if (this.initialNum === 0) {
          this.clearCounter();
        }
      }, 1000);
    },
    clearCounter() {
      clearInterval(this.timer);
      this.initialNum = 60;
      this.isRunning = false;
    },

    // 点击参会
    submitVerify() {
      if (sbaseData.isSetting) {
        return;
      }
      if (this.isValid()) {
        if (this.webinarId) {
          this.checkWithOutForm("webinar");
        } else {
          this.checkWithOutForm("seminar");
        }
      }
    },

    //线下会登录
    checkWithOutForm(type) {
      this.isHaveCode = this.extraItem.extras("verifySet.display") == 1;
      if (this.isHaveCode) {
        if (this.code.length > 0) {
          service
            .checkwithoutform({
              tenantId: parseInt(this.tenantId),
              unique: this.identity,
              checkCode: this.code,
            })
            .subscribe((data) => {
              if (data.result == "0") {
                this.checkSignUp(type);
              } else {
                this.error.codeText = data.desc;
              }
            });
        } else {
          this.error.codeText = "验证码不能为空";
        }
      } else {
        this.checkSignUp(type);
      }
    },

    checkSignUp(type) {
      if (type == "seminar") {
        this.seminarCheckSignUp();
      }
      if (type == "webinar") {
        this.webinarCheckSignUp();
      }
    },

    // 线下会看是不是报过名
    seminarCheckSignUp() {
      service
        .seminarGetsignupstatus({
          instanceId: this.instanceId,
          checkValue: this.identity,
          tenantId: parseInt(this.tenantId),
          customFormId: sbaseData.customFormId,
        })
        .subscribe((data) => {
          if (data.result == "0") {
            if (data.content.allowSignUp == "0") {
              //报过名
              this.$router.push({
                path: `${this.platform}_success`,
                query: this.d.router,
              });
              //window.location.href=window.location.href.replace('verify.html','success.html');
            } else {
              //没有报过名
              window.$sk.tips.show("请先完成报名", {
                time: 2000,
                callback: () => {
                  this.$router.push({
                    path: `${this.platform}_index`,
                    query: { urlForm: "verify" },
                  });
                },
              });
              //self.errorTip('请先完成报名');
              //self.isShowError(true);
              //setTimeout(function () {
              //  self.isShowError(false);
              //  var url=window.location.href.replace('verify.html','customForm.html');
              //  window.location.href=smarket.updateParam('urlForm','verify',url);
              //},2000);
            }
          } else {
            window.$sk.tips.show(data.desc);
            //self.errorTip(data.desc);
            //self.isShowError(true);
            //setTimeout(function () {
            //  self.isShowError(false);
            //},2000);
          }
        });
    },

    //线上会登录
    webinarCheckSignUp() {
      service
        .webinarContactsLogin({
          tenantId: this.tenantId,
          webinarId: this.webinarId,
          sess: this.member ? this.member.session : "",
          globalUserId: ck.cookie("globalUserId"),
          openId: this.openId,
          openid: this.openId,
          value: this.identity,
        })
        .subscribe(
          (data) => {
            if (data.result === 0) {
              const registration = data.content;
              if (this.formInfo.videoType == "1") {
                //是直播
                //(1:审核通过，0:拒绝，2:待审核)permission
                if (
                  registration.permission == "1" &&
                  registration.signUpId != "0"
                ) {
                  ck.cookie(
                    "registrationMember_" + this.webinarId,
                    registration
                  );
                  this.getLink("successfully");
                } else if (registration.permission == "0") {
                  this.getLink("notallow");
                } else if (registration.permission == "2") {
                  this.getLink("pending");
                } else {
                  //未报名
                  window.$sk.tips.show("请先完成报名", {
                    time: 2000,
                    callback: () => {
                      this.$router.push({
                        path: `${this.platform}_index`,
                        query: { urlForm: "verify" },
                      });
                    },
                  });

                  //self.errorTip('请先完成报名');
                  //self.isShowError(true);
                  //setTimeout(function () {
                  //  self.isShowError(false);
                  //  var url=window.location.href.replace('verify.html','customForm.html');
                  //  window.location.href=smarket.updateParam('urlForm','verify',url);
                  //}, 2000);
                }
              } else {
                if (registration.signUpId !== 0) {
                  //已报名
                  ck.cookie(
                    "registrationMember_" + this.webinarId,
                    registration
                  );
                  if (sbaseData.returnUrl) {
                    window.$sk.goto(sbaseData.returnUrl);
                  } else {
                    this.$router.push({
                      path: `${this.platform}_index`,
                      query: this.d.router,
                    });
                    //window.location.href = window.location.href.replace('verify.html','customForm.html');
                  }
                } else {
                  //未报名
                  window.$sk.tips.show("请先完成报名", {
                    time: 2000,
                    callback: () => {
                      this.$router.push({
                        path: `${this.platform}_index`,
                        query: this.d.router,
                      });
                    },
                  });
                  //self.errorTip('请先完成报名');
                  //self.isShowError(true);
                  //setTimeout(function () {
                  //  self.isShowError(false);
                  //  window.location.href = window.location.href.replace('verify.html', 'customForm.html');
                  //}, 2000);
                }
              }
            } else {
              if (parseInt(data.result) === 105007) {
                window.$sk.tips.show("已被其他用户占用，请重新输入！");
              }
            }
          },
          (error) => {
            if (parseInt(error.result) === 105007) {
              //self.errorTip('已被其他用户占用，请重新输入！');
              //self.isShowError(true);
              //setTimeout(function () {
              //  self.isShowError(false);
              //},2000);
            }
          }
        );
    },
  },
  destroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
};
